/*
 * @Author: wangwenqiu@suanier.com wangwenqiu@suanier.com
 * @Date: 2023-04-11 17:37:51
 * @LastEditors: ouyaping
 * @LastEditTime: 2023-10-20 11:36:23
 * @FilePath: \vr-exp-h5-frontend\src\types\device.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */


import Explorer from '@/assets/images/sidebar/Explorer@2x.png'
import V_S30 from '@/assets/images/sidebar/V-S30@2x.png'
import M_S30 from '@/assets/images/sidebar/V-M30@2x.png'

/**
 * 报告类型 1 EXP 2 S30
 */
export const E_DEVICE_TYPE = {
    EXP: 1,
    S30: 2,
    M30: 3,
}

/**
 * 设备类型名称 1 EXP 2 S30
 */
export const E_DEVICE_NAME_TYPE =  {
    [E_DEVICE_TYPE.EXP]: 'Visbody-R explorer',
    [E_DEVICE_TYPE.S30]: 'Visbody-S30',
    [E_DEVICE_TYPE.M30]: 'Visbody-M30',
}
/**
 * 设备类型icon 1 EXP 2 S30
 */
export const E_DEVICE_IMAGE_PATH =  {
    [E_DEVICE_TYPE.EXP]: Explorer,
    [E_DEVICE_TYPE.S30]: V_S30,
    [E_DEVICE_TYPE.M30]: M_S30,
}

/**
 * m30 体成分报告显示项
 */
export const E_M30_REPORT_ITEM = ["WT", "BFM", "FFM", "PBF"]

export function m30Test() {
    const deviceType = JSON.parse(window.localStorage.getItem('deviceType'))
    return deviceType === 3
}
